import {DateStringNullable, Dictionary, NullableKeys, todayDate} from '@fl/cmsch-fe-library';
import {opt} from 'ts-opt';

/** Form name used by the association management modal. */
export const subjectManagementFormName = 'subjectManagementForm';

/** Admin association-management form type. */
export type SubjectManagementFormTag =
    'ValidateCreateAssociationBindingManager' | 'ValidateUpdateAssociationBindingManager';

/** Admin association-management form type. */
export interface SubjectManagementFormValues {
    /** Approval start date. */
    approvedFrom: DateStringNullable;
    /** Approval end date. */
    approvedTo: DateStringNullable;
    /** Selected subject id. */
    subjectId: number;
    /** Selected role ids. */
    roleIds: Array<number>;
    /** Selected user profile id, if any. */
    userProfileId: number | null;
    /** Existing association binding ids. */
    userProfileRoleIds: Array<number>;
    /** Backend validation tag. */
    tag: SubjectManagementFormTag;
}

/**
 * Default values for the association management modal.
 *
 * @param userProfileId Selected user profile id, if any.
 * @param roleId Selected role id, if any.
 * @param subjectId Selected subject id, if any.
 * @returns Default association-management form values.
 */
export const subjectManagementFormInitialValues = (
    userProfileId: number | null,
    roleId: number | null,
    subjectId: number | null,
): NullableKeys<SubjectManagementFormValues> => ({
    approvedFrom: todayDate(),
    approvedTo: null,
    subjectId,
    roleIds: opt(roleId).toArray(),
    userProfileId,
    userProfileRoleIds: [],
    tag: 'ValidateCreateAssociationBindingManager',
});

/** Admin association-management form type. */
export type SubjectManagementFormValuesErrors = Dictionary<
    keyof SubjectManagementFormValues, string
>;
